import { render, staticRenderFns } from "./bulkIssueFreespinTab.vue?vue&type=template&id=b1bcc09a&scoped=true&lang=pug"
import script from "./bulkIssueFreespinTab.vue?vue&type=script&lang=js"
export * from "./bulkIssueFreespinTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bcc09a",
  null
  
)

export default component.exports